import axios from 'axios'
import qs from 'qs'
import oikosApi from '../../../services/oikos'
import { getRegs, selectValues } from '../../../utils/fc'
import { parseInhireCandidateCount } from './gestaoVagasHelpers'

const INHIRE_API_BASE = process.env.NODE_ENV === 'production'
  ? 'https://oikos.ecoss.is/oikos/_inhire_api.php?action='
  : '/api/integration/'

export const VAGA_LIST_FIELDS = {
  vaga_cargo: 'vaga_cargo',
  vaga_nome: 'vaga_nome',
  vaga_descricao: 'vaga_descricao',
  vaga_inhireId: 'vaga_inhireId',
  vaga_documentosObrigatorios: 'vaga_documentosObrigatorios',
  vaga_beneficios: 'vaga_beneficios',
  vaga_salarioMaximo: 'vaga_salarioMaximo',
  vaga_dtVigIni: 'vaga_dtVigIni',
  vaga_dtVigFim: 'vaga_dtVigFim',
  vaga_emailCorp: 'vaga_emailCorp',
  vaga_office365: 'vaga_office365',
  pedidoCompra_id: 'pedidoCompra_id',
  orcItem_id: 'orcItem_id',
  '(SELECT pedidoCompra_desc FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = vaga.pedidoCompra_id LIMIT 1)': 'pedidoCompra_desc',
  '(SELECT pedidoCompra_dtSolicitacao FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = vaga.pedidoCompra_id LIMIT 1)': 'pedidoCompra_dtSolicitacao',
  '(SELECT pedidoCompraStatus_id FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = vaga.pedidoCompra_id LIMIT 1)': 'pedidoCompraStatus_id',
  '(SELECT pedidoCompra_vlrLimite FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = vaga.pedidoCompra_id LIMIT 1)': 'pedidoCompra_vlrLimite',
  '(SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1)': 'pf_id',
  '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1) LIMIT 1)': 'pf_nomeExibicao',
  '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1) LIMIT 1)': 'pf_emailProf',
  '(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1)': 'orcItem_label',
  '(SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1)': 'orcRubr_id',
  '(SELECT orcRubr_mae FROM orcRubr WHERE orcRubr.orcRubr_id = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1) LIMIT 1)': 'centroDeCustoRubr_id',
  '(SELECT categGr_id FROM categ WHERE categ.categ_id = (SELECT categ_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1) LIMIT 1)': 'categGr_id',
  '(SELECT COALESCE((SELECT proj_nome FROM proj WHERE proj.orcRubr_id = (SELECT orcRubr_mae FROM orcRubr WHERE orcRubr.orcRubr_id = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1), (SELECT proj_nome FROM proj WHERE proj.orcRubr_id = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1) LIMIT 1)))': 'proj_nome',
  '(SELECT contratoForn_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1)': 'contratoForn_id',
  '(SELECT contrForn_id FROM contrForn WHERE contrForn.compraCotacao_id IN (SELECT candidato.compraCotacao_id FROM candidato WHERE candidato.vaga_id = vaga.vaga_id AND candidato.compraCotacao_id IS NOT NULL AND candidato.compraCotacao_id > 0) ORDER BY contrForn_id DESC LIMIT 1)': 'contrForn_id',
  '(SELECT contrForn_num FROM contrForn WHERE contrForn.compraCotacao_id IN (SELECT candidato.compraCotacao_id FROM candidato WHERE candidato.vaga_id = vaga.vaga_id AND candidato.compraCotacao_id IS NOT NULL AND candidato.compraCotacao_id > 0) ORDER BY contrForn_id DESC LIMIT 1)': 'contrForn_num',
  '(SELECT contrForn_desc FROM contrForn WHERE contrForn.compraCotacao_id IN (SELECT candidato.compraCotacao_id FROM candidato WHERE candidato.vaga_id = vaga.vaga_id AND candidato.compraCotacao_id IS NOT NULL AND candidato.compraCotacao_id > 0) ORDER BY contrForn_id DESC LIMIT 1)': 'contrForn_desc',
  '(SELECT COUNT(*) FROM emailEnvio e WHERE e.emailEnvio_status = \'enviado\' AND ((e.emailEnvio_tabRef = \'pedidoCompra\' AND e.emailEnvio_tabId = vaga.pedidoCompra_id) OR (e.emailEnvio_tabRef = \'compraCotacao\' AND e.emailEnvio_tabId IN (SELECT c.compraCotacao_id FROM candidato c WHERE c.vaga_id = vaga.vaga_id)) OR (e.emailEnvio_tabRef = \'contrForn\' AND e.emailEnvio_tabId IN (SELECT cf.contrForn_id FROM contrForn cf WHERE cf.compraCotacao_id IN (SELECT c.compraCotacao_id FROM candidato c WHERE c.vaga_id = vaga.vaga_id)))))': 'email_enviado_count',
}

export const CANDIDATO_FIELDS = {
  candidato_nome: 'candidato_nome',
  candidato_valorSalario: 'candidato_valorSalario',
  candidato_dtCria: 'candidato_dtCria',
  compraCotacao_id: 'compraCotacao_id',
  vaga_id: 'vaga_id',
  '(SELECT compraStatus_id FROM compraCotacao WHERE compraCotacao.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)': 'compraStatus_id',
  '(SELECT compraCotacao_nomeInteressado FROM compraCotacao WHERE compraCotacao.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)': 'compraCotacao_nomeInteressado',
  '(SELECT compraCotacao_vlr FROM compraCotacao WHERE compraCotacao.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)': 'compraCotacao_vlr',
  '(SELECT orcItem_id FROM vaga WHERE vaga.vaga_id = candidato.vaga_id LIMIT 1)': 'orcItem_id',
  '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = (SELECT orcItem_id FROM vaga WHERE vaga.vaga_id = candidato.vaga_id LIMIT 1) LIMIT 1) LIMIT 1)': 'pf_emailProf',
  '(SELECT contrForn_id FROM contrForn WHERE contrForn.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)': 'contrForn_id',
  '(SELECT contrFornStatus_id FROM contrForn WHERE contrForn.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)': 'contrFornStatus_id',
  '(SELECT contrFornStatus_nome FROM contrFornStatus WHERE contrFornStatus.contrFornStatus_id = (SELECT contrFornStatus_id FROM contrForn WHERE contrForn.compraCotacao_id = candidato.compraCotacao_id LIMIT 1) LIMIT 1)': 'contrFornStatus_nome',
  '(SELECT orcItem_id FROM contrForn WHERE contrForn.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)': 'contrForn_orcItem_id',
}

const runPool = async (items, concurrency, mapper) => {
  const results = new Array(items.length)
  let cursor = 0

  const worker = async () => {
    while (cursor < items.length) {
      const index = cursor
      cursor += 1
      results[index] = await mapper(items[index], index)
    }
  }

  const size = Math.min(concurrency, items.length) || 0
  await Promise.all(Array.from({ length: size }, worker))
  return results
}

export const fetchContrFornStatusRows = async () => {
  const rows = await getRegs('contrFornStatus')
  return Array.isArray(rows) ? rows : []
}

export const fetchCentroDeCustoOptions = async () => {
  const rows = await selectValues('orcRubr', 'orcRubr_id', 'orcRubr_nome', {
    orcRubr_ativo: 1,
    orcRubr_mae: '!IN!(1, 2)',
  })
  return (Array.isArray(rows) ? rows : []).sort((a, b) => String(a.label).localeCompare(String(b.label)))
}

export const fetchVagasRh = async () => {
  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'vaga',
    fields: VAGA_LIST_FIELDS,
  })}`)

  return (res.data || []).filter((row) => Number(row.pedidoCompra_id) > 0)
}

export const fetchCandidatosByVagaIds = async (vagaIds = []) => {
  const ids = [...new Set(vagaIds.map((id) => Number(id)).filter((id) => id > 0))]
  if (ids.length <= 0) return []

  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'candidato',
    data: {
      vaga_id: `!IN!(${ids.join(',')})`,
    },
    fields: CANDIDATO_FIELDS,
  })}`)

  return Array.isArray(res.data) ? res.data : []
}

export const fetchInhireCandidateCount = async (inhireJobId) => {
  const jobId = String(inhireJobId || '').trim()
  if (!jobId) return { count: null, error: false }

  try {
    const response = await axios.post(`${INHIRE_API_BASE}list-candidates`, { jobId })
    return {
      count: parseInhireCandidateCount(response.data),
      error: false,
    }
  } catch (error) {
    console.error('Erro ao contar candidatos no inHire:', error)
    return { count: null, error: true }
  }
}

export const fetchInhireCountsByVaga = async (vagas = []) => {
  const withInhire = vagas.filter((vaga) => String(vaga.vaga_inhireId || '').trim())
  const counts = {}
  const errors = {}

  await runPool(withInhire, 5, async (vaga) => {
    const vagaId = Number(vaga.vaga_id)
    const result = await fetchInhireCandidateCount(vaga.vaga_inhireId)
    if (result.error) {
      errors[vagaId] = true
      counts[vagaId] = null
      return
    }
    counts[vagaId] = result.count
  })

  return { counts, errors }
}
